/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import YearMonthFilterCard from '../../../../common/components/YearMonthFilterCard/YearMonthFilterCard';
import DateFilterCard from '../../../../common/components/YearMonthFilterCard/DateFilterCard';
import { Box, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { fonts, themes } from '../../../../common/themes/themes';

import './TimeSheet.css';
import { getPreviousYearsAndMonth } from '../../../../common/configs/utils';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import GetPayHistoryActionBox from '../../../../common/components/ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import CheckInCheckoutModalController from '../../../../common/Modals/Attendance/CheckInCheckoutModalController';
import {
  arabicDataGrid,
  baseDateFormatting,
  baseMonthYearFormatting,
  baseTimeFormatting,
} from '../../../../common/helper';
import { useTranslate } from '../../../../hooks';
import moment from 'moment';
import { DateField } from '../../../../components';

interface propsType {
  timesheetData: any;
  setFilterYearAndMonth: (data: any) => void;
  isLaoding?: boolean;
  trans?: any;
  callFromDateValue: (data: any) => void;
  callToDateValue: (data: any) => void;
  totalCount: number;
  setPageSize: (data: any) => void;
  setPage: (data: any) => void;
  page: number;
  pageSize: number;
  fromdate: any;
  todate: any;
}

const TimeSheetPresenter: React.FC<propsType> = ({
  timesheetData,
  setFilterYearAndMonth,
  isLaoding,
  trans,
  callFromDateValue,
  callToDateValue,
  fromdate,
  todate,
  totalCount,
  setPageSize,
  setPage,
  page,
  pageSize,
}) => {
  const [data, setData] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [limit, setLimit] = useState<number>(10);

  const handleSelectFromDate = (event: any) => {
    callFromDateValue(event);
  };
  const handleSelectToDate = (event: any) => {
    callToDateValue(event);
  };

  const [yearTitle, setyearTitle] = useState(
    moment().format(baseMonthYearFormatting),
  );

  const handelPageSize = (pageSize: number) => {
    setPageSize(pageSize);
  };

  const handelPage = (page: number) => {
    setPage(page + 1);
  };

  const tableColumns: any = [
    {
      field: 'date',
      headerName: trans('Date'),
      width: 160,
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return params?.row.date ? (
          <DateField
            value={params?.row.date}
            format={baseDateFormatting}
            offset={params?.row?.timezoneOffset}
          />
        ) : (
          '--'
        );
      },
    },
    {
      field: 'clockIn',
      headerName: trans('Clock In'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return params?.row.clockIn ? (
          <DateField
            value={params?.row.clockIn}
            format={baseTimeFormatting}
            offset={params?.row?.timezoneOffset}
          />
        ) : (
          '--'
        );
      },
    },
    {
      field: 'clockout',
      headerName: trans('Clock Out'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
      renderCell: (params: any) => {
        return params?.row.clockout ? (
          <DateField
            value={params?.row.clockout}
            format={baseTimeFormatting}
            offset={params?.row?.timezoneOffset}
          />
        ) : (
          '--'
        );
      },
    },
    {
      field: 'hoursneed',
      headerName: trans('Hours Need'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'hoursworked',
      headerName: trans('Hours Worked'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'breakHours',
      headerName: trans('Break Hours'),
      width: 140,
      headerClassName: 'header',
      height: 70,
      flex: 1,
    },
    {
      field: 'action',
      headerName: trans('Status'),
      headerClassName: 'header',
      flex: 1,
      renderCell: (params: any) => {
        const status =
          params.value == 'Present' ? (
            <Typography
              style={{
                color: themes.green,
                fontFamily: fonts.fontFamily,
                fontSize: fonts.subtitle,
                textTransform: 'capitalize',
              }}
            >
              {trans('Present')}
            </Typography>
          ) : params.value == 'Holiday' ? (
            <Typography
              style={{
                color: themes.primaryMain,
                fontFamily: fonts.fontFamily,
                fontSize: fonts.subtitle,
                textTransform: 'capitalize',
              }}
            >
              {trans('Holiday')}
            </Typography>
          ) : params.value == 'Leave' ? (
            <Typography
              style={{
                color: themes.yellow,
                fontFamily: fonts.fontFamily,
                fontSize: fonts.subtitle,
                textTransform: 'capitalize',
              }}
            >
              {trans('Leave')}
            </Typography>
          ) : params.value == 'Unpaid Leave' ? (
            <Typography
              style={{
                color: themes.yellow,
                fontFamily: fonts.fontFamily,
                fontSize: fonts.subtitle,
                textTransform: 'capitalize',
              }}
            >
              {trans('Unpaid Leave')}
            </Typography>
          ) : params.value == 'Absent' ? (
            <Typography
              style={{
                color: themes.red,
                fontFamily: fonts.fontFamily,
                fontSize: fonts.subtitle,
                textTransform: 'capitalize',
              }}
            >
              {trans('Absent')}
            </Typography>
          ) : params.value == 'Late' ? (
            <Typography
              style={{
                color: themes.red,
                fontFamily: fonts.fontFamily,
                fontSize: fonts.subtitle,
                textTransform: 'capitalize',
              }}
            >
              {trans('Late')}
            </Typography>
          ) : params.value == 'Half Day' ? (
            <Typography
              style={{
                color: themes.yellow,
                fontFamily: fonts.fontFamily,
                fontSize: fonts.subtitle,
                textTransform: 'capitalize',
              }}
            >
              {trans('Half Day')}
            </Typography>
          ) : params.value == 'Week Off' ? (
            <Typography
              style={{
                color: themes.green,
                fontFamily: fonts.fontFamily,
                fontSize: fonts.subtitle,
                textTransform: 'capitalize',
              }}
            >
              {trans('Week Off')}
            </Typography>
          ) : (
            ''
          );
        return status;
      },

      width: 100,
      height: 70,
    },
    {
      field: 'actionn',
      flex: 1,
      headerName: trans('Action'),
      headerClassName: 'header',
      width: 140,
      height: 70,
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              setOpenModal(true);
              setData(params?.row);
            }}
          />
        );
      },
    },
  ];
  const dataWithIds = timesheetData.map((row: any, index: number) => ({
    ...row,
    id: index + 1
  }));

  const { isRTL } = useTranslate();

  return (
    <>
      <DateFilterCard
        card_title={trans('TimeSheet')}
        card_height="750px"
        child_height="700px"
        fromDate={handleSelectFromDate}
        toDate={handleSelectToDate}
        from={fromdate}
        to={todate}
        yearMenu={getPreviousYearsAndMonth(trans)}
        yearTitle={yearTitle}
        trans={trans}
        ExportAll={'EmployeeAttendanceTimeSheet'}
      >
        <Box style={{ marginBottom: '24px' }} />
        {isLaoding ? (
          <Loader height={100} width={200} />
        ) : (
          <Box
            sx={{
              '& .header': {
                backgroundColor: '#F5F5F5',
              },
            }}
          >
            <DataGrid
              sx={{
                fontSize: fonts.subtitle,
                color: '#081735',
                fontFamily: fonts.fontFamily,
              }}
              autoHeight
              disableSelectionOnClick
              disableColumnMenu
              rows={dataWithIds}
              localeText={isRTL ? arabicDataGrid : undefined}
              rowsPerPageOptions={[10, 50, 100]}
              pageSize={pageSize}
              page={page - 1}
              onPageSizeChange={(newPageSize) => handelPageSize(newPageSize)} // Handle changes to the page size
              onPageChange={(page) => handelPage(page)}
              columns={tableColumns}
              rowCount={totalCount}
              getRowId={(row: any) => row.id}
              componentsProps={{
                pagination: {
                  labelRowsPerPage: trans('Rows per page'),
                },
              }}
              paginationMode="server"
            />
          </Box>
        )}
      </DateFilterCard>
      {openModal && (
        <CheckInCheckoutModalController
          closeModal={() => setOpenModal(false)}
          isModalOpen={openModal}
          trans={trans}
          data={data}
        />
      )}
    </>
  );
};
export default TimeSheetPresenter;
